// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.acceptance.LeaseDisclaimerAcceptanceWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser,
  LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser_Path,
  LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser,
  LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser_Path,
  LeaseDisclaimerAcceptanceWebApiHandler_setAttachedLeaseAcceptanceForUser,
  LeaseDisclaimerAcceptanceWebApiHandler_setDisclaimerAcceptanceForUser,
} from '@zg-rentals/ts-leasing-client';

import type {
  GetAttachedLeaseAcceptanceResponseDto,
  GetDisclaimerAcceptanceResponseDto,
  SetAttachedLeaseAcceptanceRequestDto,
  SetDisclaimerAcceptanceRequestDto,
} from '@zg-rentals/ts-leasing-client';

interface GetAttachedLeaseAcceptanceForUserParams {
  leaseId: number;
}
interface GetDisclaimerAcceptanceForUserParams {
  leaseId: number;
}

export type LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser_Options = UseQueryOptions<
  GetAttachedLeaseAcceptanceResponseDto,
  unknown,
  GetAttachedLeaseAcceptanceResponseDto,
  Array<string | GetAttachedLeaseAcceptanceForUserParams>
>;

const LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser_GetKey = (
  getParams: GetAttachedLeaseAcceptanceForUserParams,
) => [LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser_Path, getParams];

/**
 * get attached lease acceptance status for leasing user
 */
export const useLeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser = (
  getParams: GetAttachedLeaseAcceptanceForUserParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser_GetKey(getParams),
    queryFn: () => LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser(getParams, httpClient),
  });
};
useLeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser.getKey =
  LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser_GetKey;

export type LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser_Options = UseQueryOptions<
  GetDisclaimerAcceptanceResponseDto,
  unknown,
  GetDisclaimerAcceptanceResponseDto,
  Array<string | GetDisclaimerAcceptanceForUserParams>
>;

const LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser_GetKey = (
  getParams: GetDisclaimerAcceptanceForUserParams,
) => [LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser_Path, getParams];

/**
 * get disclaimer acceptance status for leasing user
 */
export const useLeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser = (
  getParams: GetDisclaimerAcceptanceForUserParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser_GetKey(getParams),
    queryFn: () => LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser(getParams, httpClient),
  });
};
useLeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser.getKey =
  LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser_GetKey;

export interface LeaseDisclaimerAcceptanceWebApiHandler_setAttachedLeaseAcceptanceForUser_Args {
  postData: SetAttachedLeaseAcceptanceRequestDto;
}

export type LeaseDisclaimerAcceptanceWebApiHandler_setAttachedLeaseAcceptanceForUser_Options = UseMutationOptions<
  void,
  unknown,
  LeaseDisclaimerAcceptanceWebApiHandler_setAttachedLeaseAcceptanceForUser_Args
>;

/**
 * set attached lease acceptance for leasing user
 */
export const useLeaseDisclaimerAcceptanceWebApiHandler_setAttachedLeaseAcceptanceForUser = ({
  httpClient,
  ...options
}: Omit<LeaseDisclaimerAcceptanceWebApiHandler_setAttachedLeaseAcceptanceForUser_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseDisclaimerAcceptanceWebApiHandler_setAttachedLeaseAcceptanceForUser_Args) =>
      LeaseDisclaimerAcceptanceWebApiHandler_setAttachedLeaseAcceptanceForUser(args.postData, httpClient),
  });
};

export interface LeaseDisclaimerAcceptanceWebApiHandler_setDisclaimerAcceptanceForUser_Args {
  postData: SetDisclaimerAcceptanceRequestDto;
}

export type LeaseDisclaimerAcceptanceWebApiHandler_setDisclaimerAcceptanceForUser_Options = UseMutationOptions<
  void,
  unknown,
  LeaseDisclaimerAcceptanceWebApiHandler_setDisclaimerAcceptanceForUser_Args
>;

/**
 * set disclaimer acceptance for leasing user
 */
export const useLeaseDisclaimerAcceptanceWebApiHandler_setDisclaimerAcceptanceForUser = ({
  httpClient,
  ...options
}: Omit<LeaseDisclaimerAcceptanceWebApiHandler_setDisclaimerAcceptanceForUser_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseDisclaimerAcceptanceWebApiHandler_setDisclaimerAcceptanceForUser_Args) =>
      LeaseDisclaimerAcceptanceWebApiHandler_setDisclaimerAcceptanceForUser(args.postData, httpClient),
  });
};
